import { mapGetters } from 'vuex'

export const authComputed = {
  ...mapGetters({
    currentUser: 'user/getCurrentUser',
    currentUserName: 'user/getCurrentUserName',
  }),
}
